export enum CreateRoomType {
  TextRoom = 'text',
  VoiceRoom = 'voice',
}

export enum CreateRoomAccess {
  Private = 'private',
  Restricted = 'restricted',
  Public = 'public',
}
